module.exports = __webpack_public_path__ + "static/media/alert.52901518.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/alert.svg
// module id = 1653
// module chunks = 0